// This file was autogenerated. Do not edit directly.

export const baseColorTokens = {
    blue100: '#f3f9ff',
    blue1000: '#101522',
    blue200: '#eaf5ff',
    blue300: '#d9edff',
    blue400: '#9ccfff',
    blue500: '#6087d9',
    blue600: '#006ccf',
    blue700: '#024d95',
    blue800: '#15325d',
    blue900: '#14233e',
    brandCyan: '#00ffff',
    brandDarkGrey: '#333333',
    brandLightCyan: '#94ffff',
    brandLightGrey: '#b2b2b2',
    brandMediumGrey: '#595959',
    brandWarmGrey: '#eceae4',
    brandWhite: '#ffffff',
    coolGray100: '#f7f8fc',
    coolGray1000: '#151516',
    coolGray200: '#f0f0f4',
    coolGray300: '#e4e5e9',
    coolGray400: '#bdbec1',
    coolGray500: '#88898b',
    coolGray600: '#6c6d6f',
    coolGray700: '#4d4e4f',
    coolGray800: '#323233',
    coolGray900: '#232424',
    cyan100: '#d2ffff',
    cyan1000: '#00191b',
    cyan200: '#adffff',
    cyan300: '#00ffff',
    cyan400: '#00d3d8',
    cyan500: '#00989d',
    cyan600: '#007a7e',
    cyan700: '#00575b',
    cyan800: '#00393c',
    cyan900: '#00292b',
    green100: '#ecfbe9',
    green1000: '#0f1808',
    green200: '#dff8da',
    green300: '#c6f1ba',
    green400: '#71d54f',
    green500: '#539938',
    green600: '#447a2c',
    green700: '#31571f',
    green800: '#203914',
    green900: '#17280d',
    orange100: '#fdf5eb',
    orange1000: '#211203',
    orange200: '#fcefde',
    orange300: '#fae2c3',
    orange400: '#f1b264',
    orange500: '#cb7311',
    orange600: '#a25b0d',
    orange700: '#754109',
    orange800: '#4d2a06',
    orange900: '#361e04',
    pink100: '#fcf8fa',
    pink1000: '#201116',
    pink200: '#f9eef2',
    pink300: '#f3e0e8',
    pink400: '#e0b1c5',
    pink500: '#c26f93',
    pink600: '#b04978',
    pink700: '#842e56',
    pink800: '#542137',
    pink900: '#391926',
    red100: '#fff4f0',
    red1000: '#22110b',
    red200: '#ffede6',
    red300: '#ffded2',
    red400: '#ffa88c',
    red500: '#f2502b',
    red600: '#c04226',
    red700: '#88311e',
    red800: '#562317',
    red900: '#3b1a12',
    seafoam100: '#edf9f3',
    seafoam1000: '#061911',
    seafoam200: '#e1f5eb',
    seafoam300: '#c8eedb',
    seafoam400: '#6cd1a0',
    seafoam500: '#289b67',
    seafoam600: '#1f7c53',
    seafoam700: '#15583b',
    seafoam800: '#0e3a27',
    seafoam900: '#0a291c',
    violet100: '#faf5fe',
    violet1000: '#181320',
    violet200: '#f6eefd',
    violet300: '#eee0fb',
    violet400: '#d1b1f4',
    violet500: '#a26fe9',
    violet600: '#8157c0',
    violet700: '#5b3f86',
    violet800: '#3b2a54',
    violet900: '#291f39',
    warmGray100: '#f7f6f4',
    warmGray1000: '#161515',
    warmGray200: '#f2f1ec',
    warmGray300: '#e7e5df',
    warmGray400: '#c0beb9',
    warmGray500: '#8a8985',
    warmGray600: '#6e6d6a',
    warmGray700: '#4f4e4c',
    warmGray800: '#333231',
    warmGray900: '#242423',
    yellow100: '#fef7d6',
    yellow1000: '#1c1502',
    yellow200: '#fef1ba',
    yellow300: '#fee57e',
    yellow400: '#e5b912',
    yellow500: '#a7850d',
    yellow600: '#87690b',
    yellow700: '#624a08',
    yellow800: '#413005',
    yellow900: '#2e2203',
};
